import { useLazyQuery } from "@apollo/client";
import { TOP_PRODUCTS_FOR_BUYER_PHARMACY } from "../reportTypeDefs";

export const useLazyQueryTopProductsForBuyer = (options?: any) =>
  useLazyQuery(TOP_PRODUCTS_FOR_BUYER_PHARMACY, options);
